import { useEffect, useRef } from "react";
import {
  useAudioVideo,
  useContentShareState,
} from "amazon-chime-sdk-component-library-react";
import { VideoMeetingTileContentShare } from "./VideoMeetingTileContentShare";

export function VideoMeetingTileContentShareContainer() {
  const audioVideo = useAudioVideo();

  const { tileId, isLocalUserSharing, sharingAttendeeId } = useContentShareState();

  const videoEl = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    if (!audioVideo || !videoEl.current || !tileId) {
      return;
    }

    audioVideo.bindVideoElement(tileId, videoEl.current);

    return () => {
      const tile = audioVideo.getVideoTile(tileId);
      if (tile) {
        audioVideo.unbindVideoElement(tileId);
      }
    };
  }, [audioVideo, tileId]);

  const isContentSharing = isLocalUserSharing || !!sharingAttendeeId;

  return tileId ? <VideoMeetingTileContentShare ref={videoEl} isContentSharing={isContentSharing} /> : null;
}

export default VideoMeetingTileContentShareContainer;
